import { Injectable, Type, ComponentRef, ApplicationRef, createComponent, EmbeddedViewRef, Injector } from '@angular/core';
import { firstValueFrom, Subject } from 'rxjs';

export class DialogRef {
  private readonly _afterClosed = new Subject<any>();
  afterClosed$ = this._afterClosed.asObservable();

  constructor() {}

  close(result?: any) {
    this._afterClosed.next(result);
  }

  afterClosed() {
    return this.afterClosed$;
  }

}
